export enum AutomationActionName {
  sendEmail = 'sendEmail',
}
